import React from "react";
import { connect } from "react-redux";
import PageHeader from "../../components/PageHeader";
import { Alert, Button, Card } from "antd";
import { removeSlashesFromPath } from "../../helpers/location/removeSlashesFromPath";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { t } from "i18next";
import { EyeOutlined } from "@ant-design/icons";
import { Space, Table, Tag, Input } from "antd";
import { getRowClassName } from "../../helpers/getRowClassName";
import { tagsBageStatus, tagsTypeBage } from "../../helpers/tagsBage";
import { getRandomuserParams, showToast, ticketIcon } from "../../utils";
import Apiauth from "../../api/Apiauth";
import moment from "moment";
import AppContext from "../../components/AppContext";
import { debounce } from "lodash";
import { DetialTicketModel } from "../../components/Model/index-model";
import SupportTicket from "../../components/SupportTicket";
import { TicketData } from "../../Data/DataTicket";
import { withTranslation } from "react-i18next";

const { Search } = Input;

class AllTicker extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      activeTabKey1: "tab1",
      show: false,
      showModelAdd: false,
      showModelEdit: false,
      isData: null,
      isLoad: false,
      isModalVisible: false,
      formData: {
        username: "",
        password: "",
      },
      dataTable: [],
      tableParams: {
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        filters: {},
        sortField: null,
        sortOrder: null,
      },
    };
    this.debouncedFetch = debounce(this.fetchData, 100);
  }

  componentDidMount() {
    // this?.fetchData?.(); // เปิดเมื่อดำเนินการเสร็จ
    if (this.context.setFetchAllTickerDataCallback) {
      this.context.setFetchAllTickerDataCallback(this.handleReload);
    }
  }
  componentWillUnmount() {
    this.debouncedFetch.cancel();
  }
  handleReload = () => {
    this.setState({ isLoad: true }, async () => {
      await Promise.all([this.debouncedFetch()]);
    });
  };

  setLoading = (_loading) => {
    this.setState({ isLoad: _loading });
  };

  fetchData = async () => {
    this.setLoading(true);
    const { tableParams } = this.state;
    const params = getRandomuserParams(tableParams);
    let now = moment().format("YYYY-MM-DD");
    // ********//
    let itemParam = {
      limit: params.limit,
      offset: params.page,
      startDate: now,
      endDate: now,
      sort: "id",
      status: "all",
    };
    try {
      const res = await Apiauth.getDataTicket(itemParam);
      if (res.data.success) {
        const fetchedData = Array.isArray(res.data.data.rows)
          ? res.data.data.rows
          : [];
        const filteredData = tableParams.filters.refUuid
          ? fetchedData.filter((item) =>
            item.refUuid
              .toLowerCase()
              .includes(tableParams.filters.refUuid.toLowerCase())
          )
          : fetchedData;

        const statusFilteredData = tableParams.filters.status
          ? filteredData.filter((item) =>
            tableParams.filters.status.includes(String(item.status))
          )
          : filteredData;
        this.setState((prevState) => ({
          dataTable: statusFilteredData,
          tableParams: {
            ...prevState.tableParams,
            pagination: {
              ...prevState.tableParams.pagination,
              total:
                statusFilteredData.length < 10
                  ? statusFilteredData.length
                  : res.data.data.count,
              current: tableParams.pagination.current, // Keep current page
              pageSize: tableParams.pagination.pageSize, // Keep current page size
            },
          },
        }));
      } else {
        showToast("error", res.message || "Failed to fetch data.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ dataTable: TicketData }); // Clear data on error
    } finally {
      this.setLoading(false);
    }
  };
  // --- FIX STARTS HERE ---
  onSearch = (value) => {
    this.setState(
      (prevState) => ({
        tableParams: {
          ...prevState.tableParams,
          pagination: {
            ...prevState.tableParams.pagination,
            current: 1,
          },
          filters: {
            ...prevState.tableParams.filters,
            refUuid: value,
          },
        },
      }),
      () => this.fetchData()
    );
  };
  // --- FIX ENDS HERE ---
  showModal = () => {
    this.setState({
      isModalVisible: true,
    });
  };
  render() {
    const {
      activeTabKey1,
      show,
      isData,
      isLoad,
      tableParams,
      dataTable,
      isModalVisible,
    } = this.state;
    const setActiveTabKey1 = (key) => {
      this.setState({ activeTabKey1: key });
    };
    const handleShow = (key) => {
      this.setState({ show: true, isData: key });
    };

    const handleClose = () => {
      this.setState({
        show: false,
        showModelAdd: false,
        showModelEdit: false,
        isData: null,
        isModalVisible: false,
      });
    };
    const onTab1Change = (key) => {
      setActiveTabKey1(key);
    };

    const tabList = [
      {
        key: "tab1",
        tab: t("ticket_list"),
      },
    ];

    const columns = [
      {
        title: t("Subject "),
        filterSearch: true,
        dataIndex: "subject",
        key: "subject",
        render: (_, record) => (
          <b style={{ color: "#3eacff" }}>
            [<small style={{ fontSize: 13 }}>Ticker#{record?.uuid}</small>]{" "}
            <small style={{ fontSize: 13 }}>{record?.subject} </small>
          </b>
        ),
      },
      {
        title: t("Submirred By"),
        filterSearch: true,
        dataIndex: "submirredBy",
        key: "submirredBy",
        render: (record) => (
          <span className="text-truncate">
            {record || (
              <em style={{ color: "#888" }}>
                <small>No data</small>
              </em>
            )}
          </span>
        ),
      },

      {
        title: t("Status "),
        dataIndex: "status",
        key: "status",
        render: (status) => {
          return (
            <Tag
              style={{ textTransform: "capitalize", fontWeight: "700" }}
              color={tagsBageStatus(status)}
              key={status}
            >
              {status}
            </Tag>
          );
        },
      },
      {
        title: t("Priority"),
        dataIndex: "priority",
        key: "priority",
        render: (record) => {
          return (
            <Tag
              style={{ textTransform: "capitalize", fontWeight: "700" }}
              color={tagsTypeBage(record)}
              key={record}
            >
              {record}
            </Tag>
          );
        },
      },

      {
        title: t("Last Reply"),
        filterSearch: true,
        dataIndex: "updated_at",
        key: "updated_at",
        render: (record) => (
          <span className="text-truncate">{FormatTimeAgo(record)}</span>
        ),
      },

      {
        title: <span className="text-truncate">{t("Action ")}</span>,
        // key: "action",
        // fixed: "right",
        // width: 100,
        render: (_, record) => {
          return (
            <>
              <Space size="middle">
                <div color="#21c8cf" title={t("Details")}>
                  <Button
                    onClick={() => handleShow(record)}
                    icon={<EyeOutlined />}
                  >
                    {" "}
                    Details
                  </Button>
                </div>
              </Space>
            </>
          );
        },
      },
    ];

    const handleTableChange = (pagination, filters, sorter) => {
      this.setState(
        (prevState) => ({
          tableParams: {
            ...prevState.tableParams,
            pagination,
            filters,
            sortField: sorter.field,
            sortOrder: sorter.order,
          },
        }),
        this.fetchData()
      );
    };

    const contentList = {
      tab1: (
        <>
          <div className="body table-responsive">
            <Table
              className="col-lg-12"
              columns={columns}
              rowKey={(record) => record.id}
              onChange={handleTableChange}
              dataSource={dataTable}
              loading={isLoad}
              pagination={{
                ...tableParams.pagination,
                showSizeChanger: true,
                locale: {
                  items_per_page: `/ ${t("paged")}`, 
                },
                showTotal: (total, range) => {
                  // คำนวณหน้าปัจจุบัน
                  const currentPage = tableParams.pagination.current;
                  // คำนวณจำนวนหน้าทั้งหมด
                  const totalPages = Math.ceil(total / tableParams.pagination.pageSize);

                  return (
                    <span>
                      {/* แสดง: หน้า 1 จาก 10 | แสดง 1-10 จาก 100 รายการ */}
                      <strong>{t("Page", { page: Intl.NumberFormat().format(currentPage), totalPages: Intl.NumberFormat().format(totalPages) })}</strong>
                      <span style={{ marginLeft: 10 }}>
                        {t("Showing", { from: Intl.NumberFormat().format(range[0]), total: Intl.NumberFormat().format(total), of: Intl.NumberFormat().format(range[1]) })}
                      </span>
                    </span>
                  );
                },
              }}
              rowClassName={getRowClassName}
              scroll={{ x: "max-content" }}
            />
          </div>
        </>
      ),
    };
    return (
      <>
        <DetialTicketModel
          handleClose={handleClose}
          isData={isData}
          show={show}
          t={t}
          title="All Ticket"
        />
        <SupportTicket
          handleClose={handleClose}
          show={isModalVisible}
          fetchData={this.fetchData}
          t={t}
        />
        <div style={{ flex: 1 }}>
          <div>
            <div className="container-fluid">
              <PageHeader
                HeaderText={t("all Ticket")}
                Breadcrumb={[
                  {
                    name: removeSlashesFromPath(window.location.pathname),
                    navigate: window.location.pathname,
                  },
                ]}
              />
              <>
                <Alert showIcon message="อยู่ระหว่างดำเนินการ..." type="info" />

                <Card
                  title={
                    <Button onClick={this.showModal} icon={ticketIcon}>
                      Add Ticket
                    </Button>
                  }
                  extra={
                    <Search
                      placeholder="Search..."
                      className=""
                      onSearch={this.onSearch}
                      enterButton
                    />
                  }
                  tabList={tabList}
                  activeTabKey={activeTabKey1}
                  onTabChange={onTab1Change}
                >
                  {contentList[activeTabKey1]}
                </Card>
              </>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({
  isInbox: mailInboxReducer.isInbox,
});

export default connect(mapStateToProps, {})(withTranslation()(AllTicker));
